// src/components/EmployeeTypeahead.jsx
import React, { useState } from "react";
import { Typeahead } from "react-bootstrap-typeahead";
import { usePopper } from "react-popper";
import { createPortal } from "react-dom";

const EmployeeTypeahead = ({
  employees,
  selectedId,
  onChange,
  placeholder = "Assign employee",
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [referenceElement, setReferenceElement] = useState(null);
  const [popperElement, setPopperElement] = useState(null);

  const { styles, attributes } = usePopper(referenceElement, popperElement, {
    placement: "bottom-start",
    modifiers: [
      {
        name: "offset",
        options: { offset: [0, 4] },
      },
      {
        name: "preventOverflow",
        options: { boundary: "viewport" },
      },
      {
        name: "flip",
        options: { fallbackPlacements: ["top-start"] },
      },
    ],
  });

  const selected = selectedId
    ? employees.filter((e) => e.id === selectedId)
    : [];

  return (
    <>
      <div ref={setReferenceElement}>
        <Typeahead
          id="employee-typeahead"
          labelKey={(opt) => `${opt.first_name} ${opt.last_name}`}
          options={employees}
          selected={selected}
          onChange={(sel) => {
            onChange(sel[0]?.id || null);
            setIsOpen(false);
          }}
          placeholder={placeholder}
          size="sm"
          clearButton
          onFocus={() => setIsOpen(true)}
          onBlur={() => setTimeout(() => setIsOpen(false), 200)}
          open={isOpen}
          flip={false}
          highlightOnlyResult={true}
          containerStyle={{ position: "relative" }}
        />
      </div>

      {isOpen &&
        createPortal(
          <div
            ref={setPopperElement}
            style={{
              ...styles.popper,
              zIndex: 1060,
              background: "white",
              border: "1px solid #ced4da",
              borderRadius: "8px",
              boxShadow: "0 6px 16px rgba(0, 0, 0, 0.15)",
              maxHeight: "240px",
              overflowY: "auto",
              minWidth: "220px",
            }}
            {...attributes.popper}
          >
            <div className="p-1">
              {employees.length > 0 ? (
                employees.map((emp) => (
                  <div
                    key={emp.id}
                    className="px-3 py-2 hover:bg-gray-100 cursor-pointer"
                    style={{
                      backgroundColor:
                        selectedId === emp.id ? "#f8f9fa" : "transparent",
                    }}
                    onMouseDown={(e) => e.preventDefault()}
                    onClick={() => {
                      onChange(emp.id);
                      setIsOpen(false);
                    }}
                  >
                    {emp.first_name} {emp.last_name}
                  </div>
                ))
              ) : (
                <div className="px-3 py-2 text-muted">No employees</div>
              )}
            </div>
          </div>,
          document.body
        )}
    </>
  );
};

export default EmployeeTypeahead;